import { render, staticRenderFns } from "./ProcessDesign.vue?vue&type=template&id=47a9077d&"
import script from "./ProcessDesign.vue?vue&type=script&lang=js&"
export * from "./ProcessDesign.vue?vue&type=script&lang=js&"
import style0 from "./ProcessDesign.vue?vue&type=style&index=0&id=47a9077d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports